module.exports = __webpack_public_path__ + "static/media/4.9545ab50.jpg";